/**
 * Step 11 · CPR Generation.  (Sprint P34 — Feb 2026)
 *
 * The user-facing page is now a single one-click experience powered
 * exclusively by `CleanCPRDashboard`. Per user directive, the previous
 * "Advanced Review — technical modules" panel has been removed.
 *
 * Internally, SRES AI still runs the full 17-step orchestrator; the
 * technical detail (health / diagnostics / tables / report-run panels)
 * remains reachable ONLY via Administration → System Diagnostics for
 * privileged accounts, never on the regular CPR page.
 */
import CleanCPRDashboard from "@/pages/wizard/cpr/CleanCPRDashboard";


export default function CPRGenerationStep({ projectId, project }) {
  return <CleanCPRDashboard projectId={projectId} project={project} />;
}
